import { sessionStorageProxy } from "@sportal/api";
import { REPORTS_CACHE_NAME } from "@sportal/api/reports";

export const SessionStorageKeys = {
  ExpiredUrl: "UrlBeforeSessionExpired",
  Reports: REPORTS_CACHE_NAME,
  IsPromoDismissed: "dismissedPromo",
};

export { sessionStorageProxy };
